import { render, staticRenderFns } from "./OpenLeadsByStage.vue?vue&type=template&id=654541ba&"
import script from "./OpenLeadsByStage.vue?vue&type=script&lang=js&"
export * from "./OpenLeadsByStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports